<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade (Almoxarifado)"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento (Almoxarifado)"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableCentroCusto"
                            :options="form.centrosCusto"
                            @change="loadFrom('centroCusto')"
                            default-option-text="Todos"
                            label="Setor (Almoxarifado)"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidadeRequisitante"
                            :options="form.unidadesRequisitantes"
                            @change="loadFrom('unidadeRequisitante')"
                            default-option-text="Todas"
                            label="Unidade requisitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestruturaRequisitante"
                            :options="form.infraestruturasRequisitantes"
                            @change="loadFrom('infraestruturaRequisitante')"
                            default-option-text="Todos"
                            label="Local de atendimento requisitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableCentroCustoRequisitante"
                            :options="form.centrosCustoRequisitantes"
                            @change="loadFrom('centroCustoRequisitante')"
                            default-option-text="Todos"
                            label="Setor requisitante"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuarioRequisitante"
                            :options="form.usuariosRequisitantes"
                            @change="loadFrom('usuarioRequisitante')"
                            default-option-text="Todos"
                            label="Usuário requisitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disableStatus"
                            :options="form.status"
                            @change="loadFrom('status')"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="disableNumero"
                            @change="loadFrom('numero')"
                            label="Número"
                            number
                            v-model="model.numero"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableGrupo"
                            :options="form.grupos"
                            @change="loadFrom('grupo')"
                            default-option-text="Todos"
                            label="Grupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.grupoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableSubgrupo"
                            :options="form.subgrupos"
                            @change="loadFrom('subgrupo')"
                            default-option-text="Todos"
                            label="Subgrupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.subgrupoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="disableMaterial"
                            :repository="repositories.relatorioRequisicao.material"
                            :request-query-string-params="autocompleteQueryStringParams.material"
                            :search-fields="autocompleteFields.material"
                            text-field="descricao"
                            label="Material"
                            uppercase
                            v-model="model.material"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click.stop="$refs.ModalDetalhes.open(item.id, prepareData())"
                        color="primary"
                        small
                        title="Exibir detalhes"
                    >
                        <rkm-icon icon="align-justify" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <ModalDetalhes
            ref="ModalDetalhes"
            :print-details="printDetails"
        />
    </div>
</template>

<script>
// Components.
import ModalDetalhes from './components/detalhe/Modal'

// Others.
import formatsFilter from '@/filters/formats'
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file } from '@/mixins'

export default {
    components: { ModalDetalhes },
    computed: {
        autocompleteQueryStringParams() {

            const params = this.prepareData()

            delete params.material_id

            return {
                material: { ...params }
            }
        },
        autocompleteFields() {

            return {
                material: [
                    { key: 'codigo_material', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            }
        },
        optionalColumns() {

            return this.columns.filter(c => c.key != 'actions' && !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableCentroCusto() {

            return !this.isPeriodoSelecionado
                || this.model.infraestruturaId === null
        },
        disableUnidadeRequisitante() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestruturaRequisitante() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeRequisitanteId === null
        },
        disableCentroCustoRequisitante() {

            return !this.isPeriodoSelecionado
                || this.model.infraestruturaRequisitanteId === null
        },
        disableUsuarioRequisitante() {

            return !this.isPeriodoSelecionado
        },
        disableStatus() {

            return !this.isPeriodoSelecionado
        },
        disableNumero() {

            return !this.isPeriodoSelecionado
        },
        disableGrupo() {

            return !this.isPeriodoSelecionado
        },
        disableSubgrupo() {

            return !this.isPeriodoSelecionado
                || this.model.grupoId === null
        },
        disableMaterial() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioRequisicao: this.getConectaSusRepository('almoxarifado.relatorioRequisicao'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
            exportacao: this.getConectaSusRepository('exportacao.almoxarifado'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            selectedAll: true,
            indeterminate: false,
            selectedCols: [
                'unidadeRequisitante',
                'infraestruturaRequisitante',
                'setorRequisitante',
                'usuarioRequisitante',
            ],
            sortBy: 'data',
            sortDesc: false,
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    class: 'col-min text-center',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                { key: 'numero', label: 'Número', sortable: true, class: 'col-min', fixed: true },
                { key: 'unidadeRequisitante', label: 'Unidade requisitante', sortable: true },
                { key: 'infraestruturaRequisitante', label: 'Local de atendimento requisitante', sortable: true },
                { key: 'setorRequisitante', label: 'Setor requisitante', sortable: true },
                { key: 'usuarioRequisitante', label: 'Usuário requisitante', sortable: true },
                { key: 'status', label: 'Status', sortable: true, class: 'text-nowrap', fixed: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center', fixed: true },
            ],
            itens: [],
        }
    },
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        load() {

            this.setLoading()

            this.repositories.relatorioRequisicao.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioRequisicao.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo' || field == 'numero') {

                return
            }

            if (field != 'material' && field != 'status') {

                field = `${field}Id`
            }

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'centroCustoId',
                'unidadeRequisitanteId',
                'infraestruturaRequisitanteId',
                'centroCustoRequisitanteId',
                'usuarioRequisitanteId',
                'status',
                'grupoId',
                'subgrupoId',
                'material',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioRequisicao.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.requisicoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            const print = (withDetails = false) => {

                this.setLoading()

                const data = this.prepareDataWithColumns()

                data.with_details = withDetails

                this.repositories.impressao.relatorioRequisicao(data)
                    .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                    .finally(() => this.unsetLoading())
            }

            this.showConfirmation('Deseja imprimir com detalhes (itens da requisição)?',
                async () => print(true),
                async () => print()
            )
        },
        exportTo() {

            const exportTo = () => {

                this.setLoading()

                const data = this.prepareDataWithColumns()

                data.with_details = false

                this.repositories.exportacao.relatorioRequisicao(data)
                    .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                    .finally(() => this.unsetLoading())
            }

            this.showConfirmation('A exportação não incluirá os detalhes (itens da requisição). Deseja continuar?',
                async () => exportTo()
            )
        },
        printDetails(requisicao) {

            this.setLoading()

            const data = this.prepareDataWithColumns()

            data.numero = requisicao.numero
            data.with_details = true

            this.repositories.impressao.relatorioRequisicao(data)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.status_descricao = data.status
                ? this.form.status.find(s => s.value == data.status).text
                : null

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            data.selectedCols = this.fields
                .filter(f => f.key != 'actions')
                .map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.createIdKeysToObject(data, ['material'])

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
</style>